import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { PacientService } from "src/services/pacient.service";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import * as moment from "moment";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";

@Component({
  selector: "app-exames-list-component",
  templateUrl: "exames-list-component.html",
  styleUrls: ["./exames-list-component.scss"],
})
export class ExamesListComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-exame.svg",
    title: "O paciente não tem nenhum exame disponível.",
    text: "Atualmente essa área é dedicada aos resultados de exames de COVID-19.",
  };
  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-exame.svg",
    title: "O paciente não tem nenhum exame disponível.",
    text: "Atualmente essa área é dedicada aos resultados de exames de COVID-19.",
  };

  userFiltro: any;
  next: any;
  examesList: any = [];
  examesListFiltered: any = [];
  filtrosSelecionados: any[] = [];
  nomeExamelistaFiltros: any[] = [];
  cnesListaFiltros: any[] = [];
  resultadolistaFiltros: any[] = [];
  dtInicio;
  dtFim;
  conteudoRevelado;

  @Output() exameClicked = new EventEmitter();

  constructor(
    private pacient: PacientService,
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private modalCtrl: ModalController
  ) { }

  async ngOnInit() {
    await this.loadData();
  }

  ordem(lista) {
    console.log('======exames', lista);
    return lista.sort((a, b) => {
      let oldDateFormatA = a.dtAtualizacao
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = b.dtAtualizacao
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    })
  }

  async detalhar(exame) {
    this.exameClicked.emit(exame);
  }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    this.userFiltro = await this.pacient.getInfo();

    try {
      const history = await this.pacient.getList(
        null,
        "tests",
        this.userFiltro.cnsPaciente
      );
      this.examesList = history.docs;
      this.next = history.next;
      this.loadSelectFilters();

      this.formatarConteudo(false);
    } catch (e) {
      console.error("error", e);
    }
    await loading.dismiss();
  }

  async loadSelectFilters() {
    this.examesList.forEach((ex) => {
      if (!this.nomeExamelistaFiltros.includes(ex.nome)) {
        this.nomeExamelistaFiltros.push(ex.nome);
      }
      if (!this.resultadolistaFiltros.includes(ex.result)) {
        this.resultadolistaFiltros.push(ex.result);
      }
      if (!this.cnesListaFiltros.includes(ex.cnes)) {
        this.cnesListaFiltros.push(ex.cnes);
      }
    });
  }

  formatarConteudo(hidden: boolean) {
    this.examesListFiltered = this.examesList.map((ex) => ({
      tipo: "EXAMES",
      nome: "Exame: " + ex.nome,
      dtAtualizacao: ex.data,
      estabelecimento: "-",
      resultado: ex.result,
      nomeExame: ex.nome,
      cns: this.userFiltro.cns,
      exame: ex.nome,
      contato: "-",
      universisdade: "-",
      id: ex.id
    }));

    if (hidden) {
      this.examesListFiltered = this.examesListFiltered.slice(0, 3);
    }
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }

    const filtro = {
      tipo,
      data,
    };
    this.revelarConteudo();

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }

    this.filter();
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.examesListFiltered = this.examesListFiltered.filter(
        (atendimento) => {
          const dtAtendimento = moment(atendimento.dtAtualizacao);
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

          return dtAtendimento.isBetween(dtInicio, dtFim);
        }
      );
      console.log(this.examesListFiltered);
    }

    if (this.filtrosSelecionados.length) {
      const nomeExameFiltro = [];
      const resultadoFiltro = [];
      const cnesFiltro = [];
      this.filtrosSelecionados.forEach((filter) => {
        switch (filter.tipo) {
          case "nomeExame":
            nomeExameFiltro.push(filter.data);
            break;
          case "resultado":
            resultadoFiltro.push(filter.data);
            break;
          case "cnes":
            cnesFiltro.push(filter.data);
            break;
        }
      });

      this.examesListFiltered = this.examesListFiltered.filter((ex) => {
        let count = 0;
        if (nomeExameFiltro.length) {
          if (nomeExameFiltro.includes(ex.exame)) {
            count += 1;
          }
        }
        if (resultadoFiltro.length) {
          if (resultadoFiltro.includes(ex.resultado)) {
            count += 1;
          }
        }
        if (cnesFiltro.length) {
          if (cnesFiltro.includes(ex.cnes)) {
            count += 1;
          }
        }
        return !!count;
      });
    }
  }
}
